module.exports = __webpack_public_path__ + "img/my-icon.f68ee611.png";